import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

// Pages
import LoginForm from './pages/Login';
import RegisterForm from './pages/Register';
import Dashboard from './pages/Dashboard';
import PokemonPage from './pages/PokemonPage';
import TaskPage from './pages/TaskPage';
import AccueilAdmin from './pages/Admin';


// Components
import StarterSelection from './components/StarterSelection';
import PrivateRoute from './components/PrivateRoute';

// Context
import { AuthProvider} from './context/AuthContext';


// Styles
import './App.css';

// Création d'une instance de QueryClient
const queryClient = new QueryClient();

// Route conditionnelle
/* const RedirectRoute = () => {
    const { user, token } = useAuth(); // Destructure both values in one call

    return (
        <Suspense fallback={<div>Chargement...</div>}>
          {(user || token) ? <Navigate to="/dashboard" /> : <Navigate to="/title" />}
        </Suspense>
      );
};
 */

// Application
const App = () => {
    

    useEffect(() => {

        document.addEventListener('dragstart', (e) => e.preventDefault());
    
        return () => {
          // Nettoie les événements pour éviter les fuites de mémoire
          document.removeEventListener('contextmenu', (e) => e.preventDefault());
          document.removeEventListener('dragstart', (e) => e.preventDefault());
        };
      }, []);

    return (
        <QueryClientProvider client={queryClient}>
            <div className="app-container">
            <Router>
            <AuthProvider>
                <Routes>
                    <Route path="/" element={<Dashboard/>} />

                    {/* <Route path="/title" element={<TitlePage />} /> */}
                    <Route path="/register" element={<RegisterForm />} />
                    <Route path="/login" element={<LoginForm />} />
                    <Route path="/Admin" element={
                        <PrivateRoute>
                            <AccueilAdmin/>
                        </PrivateRoute>
                    } />
                    <Route path="/dashboard" element={
                        <PrivateRoute> 
                            <Dashboard />
                        </PrivateRoute>
                    } />
                    <Route path="/taskpage" element={
                        <PrivateRoute> 
                            <TaskPage />
                        </PrivateRoute>
                    } />
                    <Route path="/pokemonpage" element={
                        <PrivateRoute> 
                            <PokemonPage />
                        </PrivateRoute>
                    } />
                    <Route path="/starter_selection" element={
                         <PrivateRoute> 
                            <StarterSelection />
                         </PrivateRoute>
                    } />
                    <Route path="*" element={<p>Page non trouvée</p>} />
                </Routes>
            </AuthProvider>
        </Router>
        </div>
        </QueryClientProvider>
        
    );
};

export default App;
